import { useState, useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"

const useDocumentStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('document_statuses_last_updated', 0)
    const [documentStatuses, setDocumentStatuses] = useLocalStorage('document_statuses', [])
    
    useEffect(() => {
        if( documentStatuses.length === 0 ) {
            reload()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        setLastUpdated(Date.now())
        fetch('/v0/document_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                const statuses = json.results
                setDocumentStatuses(statuses)
            })
            .catch(error => {
                console.log("DocumentStatuses reload error", error)
            })
    }

    return {
        documentStatuses,
    }
}

export default useDocumentStatuses
